export const OWNER_MODULE_NAMESPACE = 'owner';
export const OWNER_LOADING = 'OWNER_LOADING';
export const OWNER_GET_OWNERS = 'OWNER_GET_OWNERS';
export const OWNER_GET_BLOCK_OWNERS = 'OWNER_GET_BLOCK_OWNERS';
export const OWNER_SET_OWNERS = 'OWNER_SET_OWNERS';
export const OWNER_SET_BLOCK_OWNERS = 'OWNER_SET_BLOCK_OWNERS';
export const OWNER_GET_BLOCK_OWNER = 'OWNER_GET_BLOCK_OWNER';
export const OWNER_SET_BLOCK_OWNER = 'OWNER_SET_BLOCK_OWNER';



// WEBPACK FOOTER //
// ./src/store/owner/owner-types.store.ts